import React from 'react';
import '../styles/footer.css';

const API_VERSION = process.env.REACT_APP_API_VERSION;
const APP_VERSION = process.env.REACT_APP_APP_VERSION;
const BD_VERSION = process.env.REACT_APP_BD_VERSION;

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        {API_VERSION && <span className="footer-version">API: v{API_VERSION}</span>}
        {APP_VERSION && <span className="footer-version">App: v{APP_VERSION}</span>}
        {BD_VERSION && <span className="footer-version">BD: v{BD_VERSION}</span>}
      </div>
    </footer>
  );
}

export default Footer;
